document.addEventListener('DOMContentLoaded', function() {
  const productList = document.querySelector('.product-list');
  if (!productList) return;
  
  const products = Array.from(productList.querySelectorAll('product-card'));
  
  products.sort(function(a, b) {
    const skuA = a.dataset.sku || '';
    const skuB = b.dataset.sku || '';
    return skuA.localeCompare(skuB, undefined, {numeric: true});
  });
  
  products.forEach(function(product) {
    productList.appendChild(product);
  });
});